export default __webpack_public_path__ + "static/media/007-ballet dancer.464b426c.svg";